<template>
    <div class="file-view">
        <t-dialog placement="center" :visible="visible" :footer="false" :onConfirm="close" :onClose="close" class="dialog1" >
            <span slot="header">
                计算依据
                <t-button shape="circle"  @click="download111" class="downButton">
      <cloud-download-icon slot="icon" />
    </t-button>
                <div class="closeButton" @click="close"></div>
            </span>
            <iframe :src="fileUrl" style="height: 600px;width: 960px;"></iframe>

        </t-dialog>
    </div>
</template>
  
<script>
import {
    CloudDownloadIcon
} from 'tdesign-icons-vue';
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'FileView',
    components: {
    CloudDownloadIcon,
  },
    props: {
        visible:{
            type:Boolean,
            default:false
        },
        fileUrl:{
            type:String
        },
        downFileUrl:{
            type:String
        }
    },
    data() {
        return {
        };
    },
    methods: {
        close() {
            this.$emit('update:visible', false)
        },
        download111(){
            console.log(11)
            this.$download.resource(this.downFileUrl)
        }
    }
}
</script>
  
<style lang="scss" scoped></style>
  
<style lang="less">
.file-view{
    .dialog1 {
        .t-dialog__close {
        display: none;
    }
        .t-dialog{
            height: 700px;
            width: 1000px;
            border-radius: 4px;
        opacity: 1;
        border: 1px solid #e3e6ea;
        padding: 0;
        padding-bottom: 32px;
            .t-dialog__header {
            height: 57px;
            opacity: 1;
            background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
            border-bottom: 1px solid #f5f5f5;

            .t-dialog__header-content {
                display: block;
                margin-left: 24px;
                position: relative;
                .downButton{
                position: absolute;
                right: 60px;
                width: 24px;
                height: 24px;
                svg{
                    width: 16px;
                    margin: 0;
                }
            }
            }

            

            .closeButton {
                background: url('@/assets/icon/button_cleaner-3nosha.svg');
                width: 24px;
                height: 24px;
                content: "  ";
                float: right;
                right: 24px;
                position: relative;
                cursor: pointer;
            }
        }
        }
       
    }

}
</style>
  